import React, { useCallback, useEffect, useState } from 'react';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import InternalPhoto from '../../components/InternalPhoto';
import BinaryFileLink from '../../components/BinaryFileLink';
import { BINARY_RESOURCES, hasBinaryField } from '../../utils/binaryFile';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useUsers } from '../../context/usersContext';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Drawer from '../../components/Drawer';
import TooltipInfo from '../../components/TooltipInfo/';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import useSubmitLock from '../../utils/useSubmitLock';


const Admissao = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const {
    listInternals,
    listAdmissions,
    createAdmission,
    createPrescription,
    createForwarding,
    listInternalInclusion,
  } = useInternals();
  const { userInfo, requireWriteUnit, buildUnitReadParams } = useUsers();
  const {
    listDrugs,
    listDevicesOrDrains,
    listExpertise,
    listConsciousness,
    listPupils,
    listCommunication,
    listLocomotion,
  } = useAuxiliaries();
  const [internalDetails, setInternalDetails] = useState(null);
  const [inclusionDetails, setInclusionDetails] = useState(null);
  const [admissionsTimeline, setAdmissionsTimeline] = useState([]);
  const [admissionDate] = useState(new Date().toISOString());
  const [imcData, setImcData] = useState({ peso: '', altura: '', imc: '', classificacao: '' });
  const [vitalSigns, setVitalSigns] = useState({ hour: '', pa: '', p: '', t: '', hgt: '', spo2: '' });
  const [externalPrescription, setExternalPrescription] = useState({ has: '', updated: '' });
  const [prescriptionMeds, setPrescriptionMeds] = useState([{ name: '', dosage: '', frequency: '', file: null }]);
  const [hasReferrals, setHasReferrals] = useState('');
  const [forwardingsItems, setForwardingsItems] = useState([{ expertise: '', regulation_number: '', observation: '', file: null }]);
  const [usuarioEntorpecente, setUsuarioEntorpecente] = useState('');
  const [alcoholic, setAlcoholic] = useState(false);
  const [smoker, setSmoker] = useState(false);
  const [dispositivos, setDispositivos] = useState('');
  const [nivelConsciencia, setNivelConsciencia] = useState('');
  const [pupilas, setPupilas] = useState('');
  const [comunicacao, setComunicacao] = useState('');
  const [locomocao, setLocomocao] = useState('');
  const [typeMobilityAid, setTypeMobilityAid] = useState('');
  const [hdaDin, setHdaDin] = useState('');
  const [observation, setObservation] = useState('');
  const [allergy, setAllergy] = useState({ hasAllergy: '' });
  const [allergyItems, setAllergyItems] = useState([{ type: '', name: '' }]);
  const [drugsOptions, setDrugsOptions] = useState([]);
  const [devicesOptions, setDevicesOptions] = useState([]);
  const [consciousnessOptions, setConsciousnessOptions] = useState([]);
  const [pupilsOptions, setPupilsOptions] = useState([]);
  const [communicationOptions, setCommunicationOptions] = useState([]);
  const [locomotionOptions, setLocomotionOptions] = useState([]);
  const [selectedDrugs, setSelectedDrugs] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [expertiseOptions, setExpertiseOptions] = useState([]);
  const [drawer, setDrawer] = useState({ open: false, title: '', rows: [], record: null });
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const calcImc = (peso, altura) => {
    if (!peso || !altura) return { imc: '', classificacao: '' };
    const normalize = (v) => parseFloat(String(v).replace(',', '.'));
    const p = normalize(peso);
    let h = normalize(altura);
    // Permite digitar altura em centímetros (ex: 170) e converte para metros
    if (h > 10) h = h / 100;
    if (!p || !h) return { imc: '', classificacao: '' };
    const imc = p / (h * h);
    let classificacao = '';
    if (imc < 18.5) classificacao = 'baixo';
    else if (imc < 25) classificacao = 'normal';
    else if (imc < 30) classificacao = 'sobrepeso';
    else if (imc < 35) classificacao = 'obesidade1';
    else if (imc < 40) classificacao = 'obesidade2';
    else classificacao = 'obesidade3';
    return { imc: imc.toFixed(1), classificacao };
  };

  const handleImcChange = (field, value) => {
    setImcData((prev) => {
      const next = { ...prev, [field]: value };
      const { imc, classificacao } = calcImc(next.peso, next.altura);
      return { ...next, imc, classificacao };
    });
  };

  const formatValue = (value) => {
    if (!value) return '';
    if (Array.isArray(value)) return value.filter(Boolean).join(', ');
    return value;
  };

  const formatDatePtBr = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('pt-BR');
  };

  const formatPregnancy = () => {
    if (!inclusionDetails) return 'Não se aplica';
    return inclusionDetails.pregnancy ? 'Sim' : 'Não se aplica';
  };

  const formatPregnancyTime = () => inclusionDetails?.pregnancy_time || 'Não se aplica';
  const formatHealthSituation = () => inclusionDetails?.health_situation || 'Não se aplica';

  const toggleSelection = (value, setList) => {
    const id = Number(value);
    setList((prev) => (
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    ));
  };

  const handlePrescriptionChange = (index, field, value) => {
    setPrescriptionMeds((prev) => prev.map((item, i) => (
      i === index ? { ...item, [field]: value } : item
    )));
  };

  const handlePrescriptionFileChange = (index, file) => {
    setPrescriptionMeds((prev) => prev.map((item, i) => (
      i === index ? { ...item, file } : item
    )));
  };

  const addPrescriptionRow = () => {
    setPrescriptionMeds((prev) => ([...prev, { name: '', dosage: '', frequency: '', file: null }]));
  };

  const removePrescriptionRow = (index) => {
    setPrescriptionMeds((prev) => prev.filter((_, i) => i !== index));
  };

  const handleForwardingChange = (index, field, value) => {
    setForwardingsItems((prev) => prev.map((item, i) => (
      i === index ? { ...item, [field]: value } : item
    )));
  };

  const handleForwardingFileChange = (index, file) => {
    setForwardingsItems((prev) => prev.map((item, i) => (
      i === index ? { ...item, file } : item
    )));
  };

  const addForwardingRow = () => {
    setForwardingsItems((prev) => ([...prev, { expertise: '', regulation_number: '', observation: '', file: null }]));
  };

  const removeForwardingRow = (index) => {
    setForwardingsItems((prev) => prev.filter((_, i) => i !== index));
  };

  const handleVitalSignsChange = (field, value) => {
    setVitalSigns((prev) => ({ ...prev, [field]: value }));
  };

  const formatBoolean = (value) => (value ? 'Sim' : 'Não');

  const formatListNames = (list) => {
    if (!Array.isArray(list) || list.length === 0) return '';
    return list.map((item) => item?.name || item).filter(Boolean).join(', ');
  };

  const formatTimelineDate = (rec) => {
    const dataBruta = rec?.date || rec?.created_at || rec?.created || rec?.data_atendimento;
    return dataBruta
      ? new Date(dataBruta).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
      : 'Data não informada';
  };



  const buildAdmissionRows = (rec) => {
    const vitals = rec?.vital_signs || {};
    const nutrition = rec?.nutritional_status || {};
    const prescription = rec?.prescriptions || rec?.prescription || {};
    const prescriptionUpdated = typeof prescription?.items?.[0]?.updated === 'boolean'
      ? prescription.items[0].updated
      : rec?.prescription_is_updated;

    const vitalsSummary = [
      vitals?.hour ? `Hora: ${vitals.hour}` : '',
      vitals?.pa ? `PA: ${vitals.pa}` : '',
      vitals?.p ? `P: ${vitals.p}` : '',
      vitals?.t ? `T: ${vitals.t}` : '',
      vitals?.hgt ? `HGT: ${vitals.hgt}` : '',
      vitals?.spo2 ? `SpO²: ${vitals.spo2}` : '',
    ].filter(Boolean).join(' | ');

    const nutritionSummary = [
      nutrition?.weight ? `Peso: ${nutrition.weight}` : '',
      nutrition?.height ? `Altura: ${nutrition.height}` : '',
      nutrition?.imc ? `IMC: ${nutrition.imc}` : '',
    ].filter(Boolean).join(' | ');

    return [
      { label: 'Data', value: formatDatePtBr(rec?.date || rec?.created_at) },
      { label: 'Unidade', value: rec?.unit?.name || rec?.unit_name || '' },
      { label: 'Profissional de saúde', value: rec?.health_professional?.name || '' },
      { label: 'HDA + DIN', value: rec?.hda_din || '' },
      { label: 'Nível de consciência', value: rec?.level_of_consciousness?.name || '' },
      { label: 'Pupilas', value: rec?.pupils?.name || '' },
      { label: 'Comunicação', value: rec?.communication?.name || '' },
      { label: 'Locomoção', value: rec?.locomotion?.name || '' },
      { label: 'Tipo de auxílio locomoção', value: rec?.type_mobility_aid || '' },
      { label: 'Usuário de entorpecentes', value: formatBoolean(rec?.drug_user) },
      { label: 'Etilista', value: formatBoolean(rec?.alcoholic) },
      { label: 'Tabagista', value: formatBoolean(rec?.smoker) },
      { label: 'Dispositivos/drenos', value: formatBoolean(rec?.has_devices_or_drains) },
      { label: 'Dispositivos/drenos (lista)', value: formatListNames(rec?.devices_or_drains) },
      { label: 'Drogas', value: formatListNames(rec?.drugs) },
      { label: 'Alergias', value: formatListNames(rec?.allergy) },
      { label: 'Sinais vitais', value: vitalsSummary },
      { label: 'Estado nutricional', value: nutritionSummary },
      { label: 'Prescrição atualizada', value: formatBoolean(prescriptionUpdated) },
      { label: 'Evolução', value: rec?.observation || '' },
    ];
  };

  const handleOpenDrawer = (rec) => {
    setDrawer({
      open: true,
      title: 'Detalhes da admissão',
      rows: buildAdmissionRows(rec),
      record: rec,
    });
  };

  const getDrawerPrescriptionItems = (rec) => {
    const prescriptions = rec?.prescriptions || {};
    const items = prescriptions?.items || rec?.prescriptions_list || [];
    return Array.isArray(items) ? items : [];
  };

  const getDrawerForwardingItems = (rec) => {
    const forwardings = rec?.forwardings || {};
    const items = forwardings?.items || rec?.forwarding_items || [];
    return Array.isArray(items) ? items : [];
  };

  const renderDrawerTables = () => {
    const rec = drawer.record || {};
    const prescriptionsItems = getDrawerPrescriptionItems(rec);
    const forwardingItems = getDrawerForwardingItems(rec);

    return (
      <>
        <div className="app-drawer__section">
          <div className="app-drawer__section-header">
            <h5 className="app-drawer__section-title">Prescrições</h5>
          </div>
          {prescriptionsItems.length ? (
            <div className="app-drawer__table">
              {prescriptionsItems.map((item, idx) => (
                <div className="app-drawer__table-row" key={`presc-${item.id || idx}`}>
                  <div className="app-drawer__table-cell">
                    <span>Nome</span>
                    {item.name || '-'}
                  </div>
                  <div className="app-drawer__table-cell">
                    <span>Dosagem</span>
                    {item.dosage || '-'}
                  </div>
                  <div className="app-drawer__table-cell">
                    <span>Frequência</span>
                    {item.frequency || '-'}
                  </div>
                  <div className="app-drawer__table-cell">
                    <span>Arquivo</span>
                    {hasBinaryField(item, 'file') ? (
                      <BinaryFileLink resource={BINARY_RESOURCES.medicalPrescription} id={item.id} field="file" className="app-drawer__file-link">
                        Baixar
                      </BinaryFileLink>
                    ) : (
                      '-'
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="app-drawer__empty">Nenhuma prescrição registrada.</div>
          )}
        </div>

        <div className="app-drawer__section">
          <div className="app-drawer__section-header">
            <h5 className="app-drawer__section-title">Encaminhamentos</h5>
          </div>
          {forwardingItems.length ? (
            <div className="app-drawer__table">
              {forwardingItems.map((item, idx) => (
                <div className="app-drawer__table-row" key={`forward-${item.id || idx}`}>
                  <div className="app-drawer__table-cell">
                    <span>Especialidade</span>
                    {item.expertise?.name || '-'}
                  </div>
                  <div className="app-drawer__table-cell">
                    <span>Nº Regulação</span>
                    {item.regulation || '-'}
                  </div>
                  <div className="app-drawer__table-cell">
                    <span>Observação</span>
                    {item.reason || '-'}
                  </div>
                  <div className="app-drawer__table-cell">
                    <span>Arquivo</span>
                    {hasBinaryField(item, 'file') ? (
                      <BinaryFileLink resource={BINARY_RESOURCES.internalForwarding} id={item.id} field="file" className="app-drawer__file-link">
                        Baixar
                      </BinaryFileLink>
                    ) : (
                      '-'
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="app-drawer__empty">Nenhum encaminhamento registrado.</div>
          )}
        </div>
      </>
    );
  };


  const renderAdmissionItem = (rec, idx) => (
    <li key={rec.id || idx} className="timeline-item">
      <div className="timeline-date">{formatTimelineDate(rec)}</div>
      <div className="timeline-content">
        <div className="timeline-inline">
          <span>
            Admissão registrada
            {rec?.unit?.name ? ` • ${rec.unit.name}` : ''}
          </span>
          <button
            type="button"
            className="health-inline-action"
            onClick={() => handleOpenDrawer(rec)}
          >
            Ver detalhes
          </button>
        </div>
      </div>
    </li>
  );

  const handleInternalSelect = (internal) => {
    setInternalDetails(internal);
    setInclusionDetails(null);
    if (internal?.id) {
      loadAdmissions(internal.id);
    }
  };

  const allergyTypeOptions = [
    { value: 'Medicamento', label: 'Medicamentosa' },
    { value: 'Alimentação', label: 'Alimentar' },
    { value: 'Desconhecido', label: 'Desconhecido' },
  ];

  const normalizeAllergyName = (value) => (
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
  );

  const resetAdmissionForm = () => {
    setNivelConsciencia('');
    setPupilas('');
    setComunicacao('');
    setLocomocao('');
    setTypeMobilityAid('');
    setUsuarioEntorpecente('');
    setSelectedDrugs([]);
    setAlcoholic(false);
    setSmoker(false);
    setDispositivos('');
    setSelectedDevices([]);
    setVitalSigns({ hour: '', pa: '', p: '', t: '', hgt: '', spo2: '' });
    setImcData({ peso: '', altura: '', imc: '', classificacao: '' });
    setAllergy({ hasAllergy: '' });
    setAllergyItems([{ type: '', name: '' }]);
    setExternalPrescription({ has: '', updated: '' });
    setPrescriptionMeds([{ name: '', dosage: '', frequency: '', file: null }]);
    setHasReferrals('');
    setForwardingsItems([{ expertise: '', regulation_number: '', observation: '', file: null }]);
    setHdaDin('');
    setObservation('');
  };

  useEffect(() => {
    if (internalId) {
      (async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internal = response?.results?.[0];
          if (internal) {
            setInternalDetails(internal);
            setInclusionDetails(null);
          }
        } catch (err) {
          console.error('Erro ao carregar interno:', err);
        }
      })();
    }
  }, [internalId, listInternals, buildUnitReadParams]);

  useEffect(() => {
    if (!internalDetails?.id) {
      setInclusionDetails(null);
      return;
    }

    let isActive = true;
    const onlyDigits = (value) => String(value || '').replace(/\D/g, '');
    const currentInternalId = internalDetails.id;
    const currentInternalCpf = onlyDigits(internalDetails.cpf);

    const loadInclusion = async () => {
      try {
        if (!currentInternalCpf) {
          if (isActive) setInclusionDetails(null);
          return;
        }

        const response = await listInternalInclusion({ cpf: currentInternalCpf });
        const inclusionList = Array.isArray(response)
          ? response
          : response?.results || [];

        // Garante vínculo correto: usa CPF para evitar trazer inclusão de outra interna
        const filteredByCpf = inclusionList.filter((item) => (
          currentInternalCpf && onlyDigits(item?.cpf) === currentInternalCpf
        ));

        const sourceList = filteredByCpf.length ? filteredByCpf : inclusionList;

        if (!sourceList.length) {
          if (isActive) setInclusionDetails(null);
          return;
        }

        const latest = [...sourceList].sort((a, b) => {
          const aDate = new Date(a.updated_at || a.created_at || a.inclusion_date || 0).getTime();
          const bDate = new Date(b.updated_at || b.created_at || b.inclusion_date || 0).getTime();
          return bDate - aDate;
        })[0];

        // Evita race condition quando troca rápido de interno
        if (isActive && currentInternalId === internalDetails.id) {
          setInclusionDetails(latest || null);
        }
      } catch (err) {
        console.error('Erro ao buscar ficha de inclusão:', err);
        if (isActive) setInclusionDetails(null);
      }
    };

    loadInclusion();

    return () => {
      isActive = false;
    };
  }, [internalDetails?.id, internalDetails?.cpf, listInternalInclusion]);

  const loadAuxiliaries = useCallback(async () => {
    try {
      const [
        drugsData,
        devicesData,
        expertiseData,
        consciousnessData,
        pupilsData,
        communicationData,
        locomotionData,
      ] = await Promise.all([
        listDrugs(),
        listDevicesOrDrains(),
        listExpertise(),
        listConsciousness(),
        listPupils(),
        listCommunication(),
        listLocomotion(),
      ]);

      setDrugsOptions(drugsData?.results || []);
      setDevicesOptions(devicesData?.results || []);
      setExpertiseOptions(expertiseData?.results || expertiseData || []);
      setConsciousnessOptions(consciousnessData?.results || []);
      setPupilsOptions(pupilsData?.results || []);
      setCommunicationOptions(communicationData?.results || []);
      setLocomotionOptions(locomotionData?.results || []);
    } catch (err) {
      console.error('Erro ao carregar listas auxiliares:', err);
    }
  }, [
    listCommunication,
    listConsciousness,
    listDevicesOrDrains,
    listDrugs,
    listExpertise,
    listLocomotion,
    listPupils,
  ]);

  const loadAdmissions = useCallback(async (id) => {
    try {
      const res = await listAdmissions({ internal__id: id });
      const items = res?.results || res || [];
      setAdmissionsTimeline(items);
    } catch (err) {
      console.error('Erro ao carregar admissões:', err);
    }
  }, [listAdmissions]);

  useEffect(() => {
    if (internalId) {
      loadAdmissions(internalId);
    }
  }, [internalId, loadAdmissions]);

  useEffect(() => {
    loadAuxiliaries();
  }, [loadAuxiliaries]);

  const handleSubmit = async () => {
    await runWithSubmitLock(async () => {
      if (!internalDetails?.id) {
        toast.error('Selecione um interno.');
        return;
      }
      const writeUnit = requireWriteUnit();
      if (!writeUnit.ok) {
        toast.warning(writeUnit.message);
        return;
      }
      if (!hdaDin.trim()) {
        toast.error('Preencha a HDA + DIN.');
        return;
      }
      if (!nivelConsciencia || !pupilas || !comunicacao || !locomocao) {
        toast.error('Preencha todos os campos do estado neurológico.');
        return;
      }
      if (!usuarioEntorpecente) {
        toast.error('Informe se é usuário de entorpecente.');
        return;
      }
      if (usuarioEntorpecente === 'sim' && selectedDrugs.length === 0) {
        toast.error('Selecione as drogas utilizadas.');
        return;
      }
      if (!dispositivos) {
        toast.error('Informe se possui dispositivos ou drenos.');
        return;
      }
      if (dispositivos === 'sim' && selectedDevices.length === 0) {
        toast.error('Selecione os dispositivos ou drenos.');
        return;
      }
      if (!vitalSigns.hour || !vitalSigns.pa || !vitalSigns.p || !vitalSigns.t || !vitalSigns.hgt || !vitalSigns.spo2) {
        toast.error('Preencha todos os campos de sinais vitais.');
        return;
      }
      if (!imcData.peso || !imcData.altura || !imcData.imc) {
        toast.error('Preencha peso, altura e IMC.');
        return;
      }
      if (!allergy.hasAllergy) {
        toast.error('Informe se possui alergia.');
        return;
      }
      if (allergy.hasAllergy === 'sim') {
        if (!allergyItems.length) {
          toast.error('Informe pelo menos uma alergia.');
          return;
        }
        const hasInvalidAllergy = allergyItems.some((item) => !item.type || !item.name);
        if (hasInvalidAllergy) {
          toast.error('Preencha tipo e nome de todas as alergias.');
          return;
        }
      }
      if (!externalPrescription.has) {
        toast.error('Informe se possui receita externa.');
        return;
      }
      if (externalPrescription.has === 'sim' && !externalPrescription.updated) {
        toast.error('Informe se a receita está atualizada.');
        return;
      }
      if (externalPrescription.has === 'sim') {
        const hasEmptyMed = prescriptionMeds.some(
          (item) => !item.name || !item.dosage || !item.frequency
        );
        if (hasEmptyMed) {
          toast.error('Preencha todos os campos dos medicamentos.');
          return;
        }
        const hasMissingFile = prescriptionMeds.some((item) => !item.file);
        if (hasMissingFile) {
          toast.error('Anexe o arquivo de cada medicamento.');
          return;
        }
      }
      if (!hasReferrals) {
        toast.error('Informe se possui encaminhamentos.');
        return;
      }
      if (hasReferrals === 'sim') {
        const hasEmptyForwarding = forwardingsItems.some(
          (item) => !item.expertise || !item.regulation_number || !item.observation
        );
        if (hasEmptyForwarding) {
          toast.error('Preencha todos os campos dos encaminhamentos.');
          return;
        }
        const hasMissingFile = forwardingsItems.some((item) => !item.file);
        if (hasMissingFile) {
          toast.error('Anexe o arquivo de cada encaminhamento.');
          return;
        }
      }

    const nutritionalStatus = imcData.peso && imcData.altura
      ? (() => {
        const weight = Number(String(imcData.peso).replace(',', '.'));
        let height = Number(String(imcData.altura).replace(',', '.'));
        if (height > 10) height = height / 100;
        const imc = Number(String(imcData.imc).replace(',', '.'));
        return {
          weight,
          height,
          imc,
        };
      })()
      : null;

    const vitalSignsPayload = Object.values(vitalSigns).some(Boolean)
      ? {
        hour: vitalSigns.hour || '',
        pa: vitalSigns.pa || '',
        p: vitalSigns.p || '',
        t: vitalSigns.t || '',
        hgt: vitalSigns.hgt || '',
        spo2: vitalSigns.spo2 || '',
      }
      : null;

    const payload = {
      internal: internalDetails.id,
      unit: writeUnit.unitId,
      health_professional: userInfo?.id || null,
      date: admissionDate,
      level_of_consciousness: nivelConsciencia || null,
      pupils: pupilas || null,
      communication: comunicacao || null,
      locomotion: locomocao || null,
      type_mobility_aid: typeMobilityAid || '',
      vital_signs: vitalSignsPayload,
      drug_user: usuarioEntorpecente === 'sim',
      alcoholic,
      smoker,
      has_devices_or_drains: dispositivos === 'sim',
      hda_din: hdaDin || '',
      nutritional_status: nutritionalStatus,
      observation: observation || '',
      drugs: selectedDrugs,
      allergy: allergy.hasAllergy === 'sim'
        ? allergyItems.map((item) => ({
          type: item.type,
          name: normalizeAllergyName(item.name),
        }))
        : [],
      devices_or_drains: selectedDevices,
      has_prescription: externalPrescription.has === 'sim',
      prescription_is_updated: externalPrescription.updated === 'sim',
      has_forwardings: hasReferrals === 'sim',
      forwardings_are_updated: hasReferrals === 'sim',
    };

    const forwardingDetails = forwardingsItems
      .filter((item) => item.expertise || item.regulation_number || item.observation || item.file)
      .map((item) => {
        const parsedExpertise = Number(item.expertise);
        return {
          expertise: Number.isFinite(parsedExpertise) ? parsedExpertise : undefined,
          regulation: item.regulation_number || '',
          reason: item.observation || '',
          type: 'Consultas',
          pending: true,
          file: item.file || null,
        };
      });

    const hasFiles = false;

    const sendPayload = async (dataToSend) => (
      await createAdmission(dataToSend)
    );

    if (hasFiles) {
      const fd = new FormData();
      const appendIfNotEmpty = (key, value) => {
        if (value !== null && value !== undefined && value !== '') {
          fd.append(key, value);
        }
      };

      appendIfNotEmpty('internal', payload.internal);
      appendIfNotEmpty('unit', payload.unit);
      appendIfNotEmpty('health_professional', payload.health_professional);
      appendIfNotEmpty('date', payload.date);
      appendIfNotEmpty('level_of_consciousness', payload.level_of_consciousness);
      appendIfNotEmpty('pupils', payload.pupils);
      appendIfNotEmpty('communication', payload.communication);
      appendIfNotEmpty('locomotion', payload.locomotion);
      appendIfNotEmpty('drug_user', String(payload.drug_user));
      appendIfNotEmpty('alcoholic', String(payload.alcoholic));
      appendIfNotEmpty('smoker', String(payload.smoker));
      appendIfNotEmpty('vaccination_updated', String(payload.vaccination_updated));
      appendIfNotEmpty('vaccination_observation', payload.vaccination_observation);
      appendIfNotEmpty('has_devices_or_drains', String(payload.has_devices_or_drains));
      appendIfNotEmpty('hda_din', payload.hda_din);
      appendIfNotEmpty('observation', payload.observation);

      selectedDrugs.forEach((id) => fd.append('drugs[]', String(id)));
      if (payload.allergy?.length) {
        appendIfNotEmpty('allergy', JSON.stringify(payload.allergy));
      }

      if (payload.vital_signs) {
        Object.entries(payload.vital_signs).forEach(([key, value]) => {
          appendIfNotEmpty(`vital_signs[${key}]`, value);
        });
      }

      if (payload.nutritional_status) {
        Object.entries(payload.nutritional_status).forEach(([key, value]) => {
          appendIfNotEmpty(`nutritional_status[${key}]`, value);
        });
      }

      await sendPayload(fd);
    } else {
      const admissionResponse = await sendPayload(payload);
      const admissionId = admissionResponse?.id;

      if (admissionId) {
        if (externalPrescription.has === 'sim') {
          const medsToSend = prescriptionMeds.filter(
            (item) => item.name || item.dosage || item.frequency || item.file
          );
          const rows = medsToSend.length ? medsToSend : [{ name: '', dosage: '', frequency: '', file: null }];

          for (const med of rows) {
            const fdPrescription = new FormData();
            fdPrescription.append('internal', internalDetails.id);
            fdPrescription.append('admission', String(admissionId));
            fdPrescription.append('health_professional', userInfo?.id || '');
            fdPrescription.append('external', 'true');
            fdPrescription.append('updated', String(externalPrescription.updated === 'sim'));

            if (med.name) fdPrescription.append('name', med.name);
            if (med.dosage) {
              fdPrescription.append('dosage', med.dosage);
              fdPrescription.append('has_dosage', 'true');
            }
            if (med.frequency) fdPrescription.append('frequency', med.frequency);
            if (med.file instanceof File) {
              fdPrescription.append('file', med.file);
            }
            await createPrescription(fdPrescription);
          }
        }

        if (hasReferrals === 'sim') {
          for (const item of forwardingDetails) {
            const fdForwarding = new FormData();
            fdForwarding.append('internal', internalDetails.id);
            fdForwarding.append('admission', String(admissionId));
            fdForwarding.append('health_professional', userInfo?.id || '');
            fdForwarding.append('pending', 'true');
            fdForwarding.append('type', item.type || 'Consultas');
            if (item.expertise !== undefined) {
              fdForwarding.append('expertise', String(item.expertise));
            }
            if (item.regulation) {
              fdForwarding.append('regulation', item.regulation);
            }
            if (item.reason) {
              fdForwarding.append('reason', item.reason);
            }
            if (item.file instanceof File) {
              fdForwarding.append('file', item.file);
            }
            await createForwarding(fdForwarding);
          }
        }
      }
    }
      loadAdmissions(internalDetails.id);
      resetAdmissionForm();
    });
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />
        {isSelectingInternal ? (
          <InternalDataSkeleton blocks={4} />
        ) : (
          <>
        <div className="admission-header">
          <div className="admission-title">
            <h2>Admissão</h2>
            <p>Registro clínico inicial e acompanhamento do interno.</p>
          </div>
          <div className="admission-chips">
            <span className="admission-chip">Unidade: {formatValue(internalDetails?.unit_acronym)}</span>
            <span className="admission-chip">Pavilhão: {formatValue(internalDetails?.pavilion_name)}</span>
            <span className="admission-chip">Cela: {formatValue(internalDetails?.cell_name)}</span>
          </div>
        </div>

        <section className='admission-hero'>
          <div className='admission-hero-avatar'>
            <InternalPhoto internal={internalDetails} alt={internalDetails?.name || 'Foto interno'} />
          </div>
          <div className='admission-hero-content'>
            <div className="admission-hero-row admission-hero-row--3">
              <div className="admission-info-item">
                <span>Nome</span>
                <strong>{formatValue(internalDetails?.name)}</strong>
              </div>
              <div className="admission-info-item">
                <span>Nome da mãe</span>
                <strong>{formatValue(internalDetails?.mothers_name)}</strong>
              </div>
              <div className="admission-info-item">
                <span>Vulgo</span>
                <strong>{formatValue(internalDetails?.aka)}</strong>
              </div>
            </div>
            <div className="admission-hero-row admission-hero-row--2">
              <div className="admission-info-item">
                <span>CPF</span>
                <strong>{formatValue(internalDetails?.cpf)}</strong>
              </div>
              <div className="admission-info-item">
                <span>Nascimento</span>
                <strong>{formatDatePtBr(internalDetails?.date_of_birth)}</strong>
              </div>
            </div>
          </div>
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Dados da inclusão</h3>
          </div>
          {!inclusionDetails && (
            <p className="health-note">Não existe ficha de inclusão para este interno.</p>
          )}
          <div className="admission-hero-row">
            <div className="admission-info-item">
              <span>Gestante</span>
              <strong>{formatPregnancy()}</strong>
            </div>
            <div className="admission-info-item">
              <span>Tempo de gravidez</span>
              <strong>{formatPregnancyTime()}</strong>
            </div>
            <div className="admission-info-item">
              <span>Situação de saúde</span>
              <strong>{formatHealthSituation()}</strong>
            </div>
          </div>
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>História da Doença Atual (HDA) + DIN</h3>
            <span className="admission-card__hint">Descrição livre do quadro clínico e rastreio.</span>
          </div>
          <div className="social-form-group admission-form">
            <textarea
              rows={5}
              placeholder="Descreva informações essenciais para planejamento do cuidado, identificação da queixa principal incluindo início, evolução, fatores de melhora ou piora, rastreio de sintomas de doenças infectocontagiosas, histórico de doenças anteriores, cirurgias, alergias, doenças de pele etc..."
              value={hdaDin}
              onChange={(e) => setHdaDin(e.target.value)}
            />
          </div>
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Estado Neurológico</h3>
          </div>
          <div className="admission-grid admission-grid--2">
            <div className="health-option-set">
              <p className="health-subtitle">Nível de Consciência</p>
              <div className="health-options-row">
                {consciousnessOptions.map((opt) => (
                  <label key={opt.id} className="health-option">
                    <input
                      type="radio"
                      name="nivel-consciencia"
                      checked={String(nivelConsciencia) === String(opt.id)}
                      onChange={() => setNivelConsciencia(opt.id)}
                    /> {opt.name}
                  </label>
                ))}
              </div>
            </div>
            <div className="health-option-set">
              <p className="health-subtitle">Pupilas</p>
              <div className="health-options-row">
                {pupilsOptions.map((opt) => (
                  <label key={opt.id} className="health-option">
                    <input
                      type="radio"
                      name="pupilas"
                      checked={String(pupilas) === String(opt.id)}
                      onChange={() => setPupilas(opt.id)}
                    /> {opt.name}
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="admission-grid admission-grid--2">
            <div className="health-option-set">
              <p className="health-subtitle">Comunicação</p>
              <div className="health-options-row">
                {communicationOptions.map((opt) => (
                  <label key={opt.id} className="health-option">
                    <input
                      type="radio"
                      name="comunicacao"
                      checked={String(comunicacao) === String(opt.id)}
                      onChange={() => setComunicacao(opt.id)}
                    /> {opt.name}
                  </label>
                ))}
              </div>
            </div>
            <div className="health-option-set">
              <p className="health-subtitle">Locomoção</p>
              <div className="health-options-row">
                {locomotionOptions.map((opt) => (
                  <label key={opt.id} className="health-option">
                    <input
                      type="radio"
                      name="locomocao"
                      checked={String(locomocao) === String(opt.id)}
                      onChange={() => setLocomocao(opt.id)}
                    /> {opt.name}
                  </label>
                ))}
              </div>
              <div className="health-inline-input-group">
                <label>
                  Tipo de auxílio de locomoção
                  <TooltipInfo text="Ex.: bengala, andador, muletas ou outros objetos de apoio." />
                </label>
                <input
                  type="text"
                  className="health-inline-input admission-input"
                  placeholder="Descreva o auxílio utilizado"
                  value={typeMobilityAid}
                  onChange={(e) => setTypeMobilityAid(e.target.value)}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Hábitos Nocivos</h3>
          </div>
          <div className="admission-grid admission-grid--2">
            <div className="health-option-set">
              <p className="health-subtitle">Usuário de entorpecente?</p>
              <div className="health-options-row">
                <label className="health-option">
                  <input
                    type="radio"
                    name="entorpecente"
                    checked={usuarioEntorpecente === 'nao'}
                    onChange={() => {
                      setUsuarioEntorpecente('nao');
                      setSelectedDrugs([]);
                    }}
                  /> Não
                </label>
                <label className="health-option">
                  <input
                    type="radio"
                    name="entorpecente"
                    checked={usuarioEntorpecente === 'sim'}
                    onChange={() => setUsuarioEntorpecente('sim')}
                  /> Sim
                </label>
                <label className="health-option">
                  <input
                    type="checkbox"
                    checked={alcoholic}
                    onChange={(e) => setAlcoholic(e.target.checked)}
                  /> Etilista
                </label>
                <label className="health-option">
                  <input
                    type="checkbox"
                    checked={smoker}
                    onChange={(e) => setSmoker(e.target.checked)}
                  /> Tabagista
                </label>
              </div>
            </div>
            <div className="health-option-set">
              <p className="health-subtitle">Quais?</p>
              {usuarioEntorpecente === 'sim' && (
                <div className="checkbox-group2">
                  {drugsOptions.map((drug) => (
                    <label key={drug.id}>
                      <input
                        type="checkbox"
                        value={drug.id}
                        checked={selectedDrugs.includes(drug.id)}
                        onChange={(e) => toggleSelection(e.target.value, setSelectedDrugs)}
                      />
                      {drug.name}
                    </label>
                  ))}
                </div>
              )}
            </div>
          </div>
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Dispositivos e/ou Drenos</h3>
          </div>
          <div className="health-options-row">
            <label className="health-option">
              <input
                type="radio"
                name="dispositivos"
                checked={dispositivos === 'nao'}
                onChange={() => {
                  setDispositivos('nao');
                  setSelectedDevices([]);
                }}
              /> Não
            </label>
            <label className="health-option">
              <input
                type="radio"
                name="dispositivos"
                checked={dispositivos === 'sim'}
                onChange={() => setDispositivos('sim')}
              /> Sim / Quais
            </label>
          </div>
          {dispositivos === 'sim' && (
            <div className="checkbox-group2">
              {devicesOptions.map((device) => (
                <label key={device.id}>
                  <input
                    type="checkbox"
                    value={device.id}
                    checked={selectedDevices.includes(device.id)}
                    onChange={(e) => toggleSelection(e.target.value, setSelectedDevices)}
                  />
                  {device.name}
                </label>
              ))}
            </div>
          )}
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Sinais Vitais</h3>
          </div>
          <div className="admission-grid admission-grid--3">
            <div className="social-form-group">
              <label>Hora</label>
              <input
                type="time"
                value={vitalSigns.hour}
                onChange={(e) => handleVitalSignsChange('hour', e.target.value)}
              />
            </div>
            <div className="social-form-group">
              <label>PA</label>
              <input
                type="text"
                placeholder="Ex: 120x80"
                value={vitalSigns.pa}
                onChange={(e) => handleVitalSignsChange('pa', e.target.value)}
              />
            </div>
            <div className="social-form-group">
              <label>P</label>
              <input
                type="text"
                value={vitalSigns.p}
                onChange={(e) => handleVitalSignsChange('p', e.target.value)}
              />
            </div>
            <div className="social-form-group">
              <label>T</label>
              <input
                type="text"
                value={vitalSigns.t}
                onChange={(e) => handleVitalSignsChange('t', e.target.value)}
              />
            </div>
            <div className="social-form-group">
              <label>HGT</label>
              <input
                type="text"
                value={vitalSigns.hgt}
                onChange={(e) => handleVitalSignsChange('hgt', e.target.value)}
              />
            </div>
            <div className="social-form-group">
              <label>SpO²</label>
              <input
                type="text"
                value={vitalSigns.spo2}
                onChange={(e) => handleVitalSignsChange('spo2', e.target.value)}
              />
            </div>
          </div>
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Estado Nutricional</h3>
          </div>
          <div className="admission-grid admission-grid--3">
            <div className="social-form-group">
              <label>Peso (Kg)</label>
              <input
                type="text"
                value={imcData.peso}
                onChange={(e) => handleImcChange('peso', e.target.value)}
              />
            </div>
            <div className="social-form-group">
              <label>Altura (m)</label>
              <input
                type="text"
                value={imcData.altura}
                onChange={(e) => handleImcChange('altura', e.target.value)}
              />
            </div>
            <div className="social-form-group">
              <label>IMC (Kg/m²)</label>
              <input type="text" readOnly value={imcData.imc} />
            </div>
          </div>
          <div className="health-table">
            <div className="health-table-row header">
              <div>IMC (Kg/m²)</div>
              <div>Classificação</div>
            </div>
            {[
              ['Abaixo de 18,5', 'Abaixo do peso', 'baixo'],
              ['18,5 – 24,9', 'Peso Normal', 'normal'],
              ['24,9 – 29,9', 'Sobrepeso', 'sobrepeso'],
              ['30 – 34,9', 'Obesidade Grau I', 'obesidade1'],
              ['35 – 39,9', 'Obesidade Grau II', 'obesidade2'],
              ['Maior ou igual a 40', 'Obesidade Grau III', 'obesidade3'],
            ].map(([imc, classif, key]) => (
              <div key={imc} className={`health-table-row ${imcData.classificacao === key ? 'active' : ''}`}>
                <div>{imc}</div>
                <div>{classif}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Alergias</h3>
          </div>
          <div className="health-options-row">
            <span>Possui alergia?</span>
            <label className="health-option">
              <input
                type="radio"
                name="hasAllergy"
                checked={allergy.hasAllergy === 'nao'}
                onChange={() => {
                  setAllergy({ hasAllergy: 'nao' });
                  setAllergyItems([{ type: '', name: '' }]);
                }}
              /> Não
            </label>
            <label className="health-option">
              <input
                type="radio"
                name="hasAllergy"
                checked={allergy.hasAllergy === 'sim'}
                onChange={() => setAllergy(prev => ({ ...prev, hasAllergy: 'sim' }))}
              /> Sim / Qual?
            </label>
          </div>

          {allergy.hasAllergy === 'sim' && (
            <>
              <div className="health-list">
                {allergyItems.map((item, index) => (
                  <div key={`allergy-${index}`} className="admission-grid admission-grid--2 health-list__row">
                    <div className="social-form-group">
                      <label>Tipo de alergia</label>
                      <select
                        value={item.type}
                        onChange={(e) => {
                          const next = [...allergyItems];
                          next[index] = { ...next[index], type: e.target.value };
                          setAllergyItems(next);
                        }}
                      >
                        <option value="">Selecione</option>
                        {allergyTypeOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                      
                    </div>
                    <div className="social-form-group">
                      <label>Nome da alergia</label>
                      <div className="health-inline-grid">
                        <input
                          type="text"
                          value={item.name}
                          onChange={(e) => {
                            const next = [...allergyItems];
                            next[index] = { ...next[index], name: normalizeAllergyName(e.target.value) };
                            setAllergyItems(next);
                          }}
                          placeholder="Ex: DIPIRONA"
                        />
                        {allergyItems.length > 1 && (
                          <button
                            type="button"
                            className="health-inline-remove"
                            onClick={() => {
                              setAllergyItems((prev) => prev.filter((_, idx) => idx !== index));
                            }}
                          >
                            ×
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="health-row-below">
                  <button
                    type="button"
                    className="health-action-btn"
                    onClick={() => setAllergyItems((prev) => ([...prev, { type: '', name: '' }]))}
                  >
                    +
                  </button>
                </div>
              </div>
            </>
          )}
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Medicamentos em uso</h3>
          </div>
          <div className="health-options-row">
            <span>Possui receita externa?</span>
            <label className="health-option">
              <input
                type="radio"
                name="recipe"
                checked={externalPrescription.has === 'nao'}
                onChange={() => {
                  setExternalPrescription({ has: 'nao', updated: '' });
                  setPrescriptionMeds([{ name: '', dosage: '', frequency: '', file: null }]);
                }}
              /> Não
            </label>
            <label className="health-option">
              <input
                type="radio"
                name="recipe"
                checked={externalPrescription.has === 'sim'}
                onChange={() => setExternalPrescription({ has: 'sim', updated: '' })}
              /> Sim
            </label>
            {externalPrescription.has === 'sim' && (
              <>
                <span>Está atualizada?</span>
                <label className="health-option">
                  <input
                    type="radio"
                    name="recipe-updated"
                    checked={externalPrescription.updated === 'sim'}
                    onChange={() => setExternalPrescription(prev => ({ ...prev, updated: 'sim' }))}
                  /> Sim
                </label>
                <label className="health-option">
                  <input
                    type="radio"
                    name="recipe-updated"
                    checked={externalPrescription.updated === 'nao'}
                    onChange={() => setExternalPrescription(prev => ({ ...prev, updated: 'nao' }))}
                  /> Não
                </label>
              </>
            )}
          </div>
          <p className="health-note">Cadastro separado: as informações serão salvas após registrar a admissão.</p>

          {externalPrescription.has === 'sim' && (
            <div className="health-table three-cols">
              <div className="health-table-row header">
                <div>Nome</div>
                <div>Dosagem</div>
                <div>Frequência</div>
              </div>
              {prescriptionMeds.map((med, index) => (
                <React.Fragment key={`med-${index}`}>
                  <div className="health-table-row">
                    <div>
                      <input
                        type="text"
                        className="health-inline-input"
                        placeholder="Nome"
                        value={med.name}
                        onChange={(e) => handlePrescriptionChange(index, 'name', e.target.value)}
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        className="health-inline-input"
                        placeholder="Dosagem"
                        value={med.dosage}
                        onChange={(e) => handlePrescriptionChange(index, 'dosage', e.target.value)}
                      />
                    </div>
                    <div className="health-input-actions">
                      <input
                        type="text"
                        className="health-inline-input"
                        placeholder="Frequência"
                        value={med.frequency}
                        onChange={(e) => handlePrescriptionChange(index, 'frequency', e.target.value)}
                      />
                      <div className="health-inline-actions">
                        {prescriptionMeds.length > 1 && (
                          <button
                            type="button"
                            className="health-action-btn danger"
                            onClick={() => removePrescriptionRow(index)}
                          >
                            x
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="health-row-file">
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(e) => handlePrescriptionFileChange(index, e.target.files[0])}
                    />
                  </div>
                  {index === prescriptionMeds.length - 1 && (
                    <div className="health-row-below">
                      <button
                        type="button"
                        className="health-action-btn"
                        onClick={addPrescriptionRow}
                      >
                        +
                      </button>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Encaminhamentos</h3>
          </div>
          <div className="health-options-row">
            <span>Possui consultas e / ou exames pendentes?</span>
            <label className="health-option">
              <input
                type="radio"
                name="referrals"
                checked={hasReferrals === 'nao'}
                onChange={() => {
                  setHasReferrals('nao');
                  setForwardingsItems([{ expertise: '', regulation_number: '', observation: '', file: null }]);
                }}
              /> Não
            </label>
            <label className="health-option">
              <input
                type="radio"
                name="referrals"
                checked={hasReferrals === 'sim'}
                onChange={() => setHasReferrals('sim')}
              /> Sim
            </label>
          </div>
          <p className="health-note">Cadastro separado: as informações serão salvas após registrar a admissão.</p>
          {hasReferrals === 'sim' && (
            <div className="health-table three-cols">
              <div className="health-table-row header">
                <div>Especialidades</div>
                <div>Nº Regulação</div>
                <div>Observações</div>
              </div>
              {forwardingsItems.map((item, index) => (
                <React.Fragment key={`forward-${index}`}>
                  <div className="health-table-row">
                    <div>
                      <select
                        className="health-inline-input"
                        value={item.expertise}
                        onChange={(e) => handleForwardingChange(index, 'expertise', e.target.value)}
                      >
                        <option value="">Selecione</option>
                        {expertiseOptions.map((expertise) => (
                          <option key={expertise.id} value={expertise.id}>
                            {expertise.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <input
                        type="text"
                        className="health-inline-input"
                        placeholder="Nº Regulação"
                        value={item.regulation_number}
                        onChange={(e) => handleForwardingChange(index, 'regulation_number', e.target.value)}
                      />
                    </div>
                    <div className="health-input-actions">
                      <input
                        type="text"
                        className="health-inline-input"
                        placeholder="Informar modo de aquisição: publico, privado e/ou sob responsabilidade familiar"
                        value={item.observation}
                        onChange={(e) => handleForwardingChange(index, 'observation', e.target.value)}
                      />
                      <TooltipInfo position='left' text="Informar modo de aquisição: publico, privado e/ou sob responsabilidade familiar" />
                      <div className="health-inline-actions">
                        {forwardingsItems.length > 1 && (
                          <button
                            type="button"
                            className="health-action-btn danger"
                            onClick={() => removeForwardingRow(index)}
                          >
                            x
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="health-row-file">
                    <input
                      type="file"
                      accept="application/pdf"
                      onChange={(e) => handleForwardingFileChange(index, e.target.files[0])}
                    />
                  </div>
                  {index === forwardingsItems.length - 1 && (
                    <div className="health-row-below">
                      <button
                        type="button"
                        className="health-action-btn"
                        onClick={addForwardingRow}
                      >
                        +
                      </button>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </section>

        <section className="admission-card">
          <div className="admission-card__header">
            <h3>Observação de Enfermagem</h3>
          </div>
          <div className="social-form-group admission-form">
            <textarea
              rows={4}
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
              placeholder=""
            />
          </div>
        </section>

        <div className="admission-actions">
          <button type="button" className="social-submit-button" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'Salvando...' : 'Salvar admissão'}
          </button>
        </div>


        <section className="timeline admission-timeline">
          <h4 className="h4-title">Linha do tempo de admissões</h4>
          <ul className="timeline-list">
            {admissionsTimeline.length > 0 ? (
              [...admissionsTimeline].reverse().map(renderAdmissionItem)
            ) : (
              <p>Nenhuma admissão registrada.</p>
            )}
          </ul>
        </section>
          </>
        )}


      </div>

      <Drawer
        open={drawer.open}
        title={drawer.title}
        rows={drawer.rows}
        onClose={() => setDrawer({ open: false, title: '', rows: [], record: null })}
        wide
      >
        {renderDrawerTables()}
      </Drawer>
    </div>
  );
};

export default Admissao;
